let language = {
    "manual_order": "manually",
    "automatic_order": "periodically",
    "direct_order": "directly",
};

export { language }